import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@diamond-design/components';
import CtaButton from '../ctaButton/ctaButton';
import RadioIcon from './icons/RadioIcon';
import styles from './AddressConfirmModal.module.scss';

export default function AddressConfirmModal({
  open,
  onContinue,
  onEditAddress,
  standardized,
  entered,
  isLoading,
  title = 'Confirm your address',
  continueLabel = 'Continue',
  editAddressLabel = 'Edit Address',
}) {
  const [selected, setSelected] = useState('recommended');

  useEffect(() => {
    if (open) setSelected('recommended');
  }, [open]);

  const handleContinue = () => {
    onContinue(selected === 'recommended' ? standardized : entered);
  };

  return (
    <Modal
      open={open}
      onDismiss={onEditAddress}
      title={title}
      titleStyles={styles.modalTitle}
      size="sm"
      childrenContainerStyle={styles.modalBody}
      actions={[
        {
          label: 'actions',
          render: () => (
            <div className={styles.actions}>
              <CtaButton
                variant="secondary"
                size="lg"
                label={continueLabel}
                onClick={handleContinue}
                disabled={isLoading}
              />
              <CtaButton
                variant="primary"
                size="lg"
                label={editAddressLabel}
                onClick={onEditAddress}
              />
            </div>
          ),
        },
      ]}
    >
      <div className={styles.radioCards}>
        <label
          htmlFor="address-recommended"
          className={`${styles.card} ${
            selected === 'recommended' ? styles.selected : ''
          }`}
        >
          <input
            id="address-recommended"
            type="radio"
            name="addressChoice"
            value="recommended"
            checked={selected === 'recommended'}
            onChange={() => setSelected('recommended')}
            className={styles.radioInput}
          />
          <RadioIcon selected={selected === 'recommended'} />
          <div className={styles.cardContent}>
            <span className={styles.cardTitle}>Recommended Address</span>
            <span className={styles.cardAddressLine}>
              {standardized?.street}
            </span>
            <span className={styles.cardAddressLine}>
              {standardized?.city}, {standardized?.state} {standardized?.zip}
            </span>
          </div>
        </label>

        <label
          htmlFor="address-entered"
          className={`${styles.card} ${
            selected === 'entered' ? styles.selected : ''
          }`}
        >
          <input
            id="address-entered"
            type="radio"
            name="addressChoice"
            value="entered"
            checked={selected === 'entered'}
            onChange={() => setSelected('entered')}
            className={styles.radioInput}
          />
          <RadioIcon selected={selected === 'entered'} />
          <div className={styles.cardContent}>
            <span className={styles.cardTitle}>Entered Address</span>
            <span className={styles.cardAddressLine}>{entered?.street}</span>
            <span className={styles.cardAddressLine}>
              {entered?.city}, {entered?.state} {entered?.zip}
            </span>
          </div>
        </label>
      </div>
    </Modal>
  );
}

AddressConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
  onEditAddress: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  standardized: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  entered: PropTypes.shape({
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  title: PropTypes.string,
  continueLabel: PropTypes.string,
  editAddressLabel: PropTypes.string,
};
